export default __webpack_public_path__ + "static/media/new-promptplus-secondary-logo-default.e8b33b68.png";